import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProgressBar } from '../stories/ProgressBar';

interface UnitsProgressBarProps {
  percentage: number;
  numberOfCompleted: number;
  total: number;
}

export const UnitsProgressBar = (props: UnitsProgressBarProps) => {
  const __ = useTranslation().t;
  return (
    <div>
      <ProgressBar
        now={props.percentage}
        tooltipText={__('currentProgressOutOfTotal', {
          1: props.numberOfCompleted,
          2: props.total,
        })}
        variant="info"
        className="margin-right"
      />
      <h5>{__('units')}</h5>
    </div>
  );
};
